import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'BONUS #1 Pack de Disclaimers y Acuerdos Listos',
  description: 'Textos profesionales de consentimiento, límites legales y protección ética listos para usar desde hoy.'
}, {
  title: 'BONUS #2 Banco de Frases y Scripts PRO',
  description: 'Scripts de WhatsApp e Instagram, frases de apertura, reencuadre, límites y cierre con lenguaje cálido y profesional.'
}, {
  title: 'BONUS #3 Kit de Pricing y Paquetes',
  description: 'Cómo presentar tus precios con confianza, estructurar paquetes de sesiones y responder "¿cuánto sale?" sin justificarte.'
}, {
  title: 'BONUS #4 Checklist "Sesión Impecable"',
  description: 'Control de calidad rápido en una hoja imprimible para que ninguna sesión quede incompleta o sin cierre.'
}, {
  title: 'BONUS #5 Mini Guía de Contenido para Redes',
  description: '30 ideas de contenido listas para Instagram que posicionan tu perfil como facilitadora profesional y atraen consultantes.'
}, {
  title: 'BONUS #6 FAQ Lista para Instagram o Web',
  description: 'Respuestas profesionales a las preguntas más frecuentes de tus consultantes, lista para copiar y pegar en tu bio, stories o landing.'
}];
export function BonusesSection() {
  return <section className="py-12 md:py-24 px-4 relative bg-mystic-900 overflow-hidden" data-id="element-24">
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-dark/5 rounded-full filter blur-[100px] pointer-events-none" data-id="element-25"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-26">
        <div className="text-center mb-8 md:mb-16" data-id="element-27">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-5xl font-serif font-bold mb-3 md:mb-4" data-id="element-28">
            ¡GRATIS por el día de hoy! <br data-id="element-29" />
            <span className="text-gradient-gold" data-id="element-30">
              Además, llevás estos BONOS EXCLUSIVOS
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-xl text-gray-300" data-id="element-31">
            Incluidos sin costo adicional con tu compra de hoy
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-32">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="glass-card p-5 md:p-8 rounded-2xl border-t-4 border-t-gold relative overflow-hidden group" data-id="element-33">
              <div className="absolute top-0 right-0 w-16 h-16 md:w-24 md:h-24 bg-gold/10 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110" data-id="element-34"></div>

              <div className="text-3xl md:text-4xl mb-3 md:mb-6" data-id="element-35">🎁</div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-4 leading-snug" data-id="element-36">
                {bonus.title}
              </h3>
              <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-37">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}